import { DWS } from '@interfaces/dws';

/** CRM `channel_types.id` / `channels.id` for winery / price-list (ChannelType.WINERY / Channel.POS). */
const WINERY_CHANNEL_TYPE_ID = 2;

/**
 * Canale di vendita tag matcher: synthetic "Ecommerce" (WS-3837) + winery channels (listini).
 * Sentinel id must match {@code PurchasedFromChannel.ECOMMERCE_SENTINEL}.
 */
export const ECOMMERCE_SALES_CHANNEL_OPTION_ID = 'ecommerce';

export function salesChannelMatcherOptions(
  channels: DWS.WineryChannel[] | undefined | null
): Array<{ id: string; name: string }> {
  const ecommerce = { id: ECOMMERCE_SALES_CHANNEL_OPTION_ID, name: 'Ecommerce' };
  const list = activeWineryChannels(channels).map((ch) => ({
    id: String(ch.id),
    name: ch.name || String(ch.id),
  }));
  return [ecommerce, ...list];
}

export function activeWineryChannels(channels: DWS.WineryChannel[] | undefined | null): DWS.WineryChannel[] {
  return (channels || []).filter((channel) => !channel.deletedAt);
}

export function wineryChannelCode(channel: DWS.WineryChannel | undefined | null): string {
  return channel?.channel?.code ?? '';
}

export function isWineryPriceListChannel(channel: DWS.WineryChannel): boolean {
  if (wineryChannelCode(channel) === 'winery') {
    return true;
  }

  const channelId = channel.channel?.id;
  if (channelId === WINERY_CHANNEL_TYPE_ID || channelId === String(WINERY_CHANNEL_TYPE_ID)) {
    return true;
  }

  const channelType = channel.channel?.channelType as unknown;
  if (typeof channelType === 'string') {
    return channelType === 'winery' || channelType === String(WINERY_CHANNEL_TYPE_ID);
  }

  if (channelType && typeof channelType === 'object') {
    const typed = channelType as { id?: number | string; code?: string };
    if (typed.id === WINERY_CHANNEL_TYPE_ID || typed.id === String(WINERY_CHANNEL_TYPE_ID)) {
      return true;
    }
    if (typed.code === 'winery') {
      return true;
    }
  }

  return false;
}
